/**
 * @desc 新增销售计划详情
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {}

export function request(
  data: Array<defs.TheNewSalesPlanQuarterlyWeeks>,
): Promise<defs.StandardReturn<boolean>> {
  return defHttp.post({
    url: '/web/plan/add',
    data,
  });
}

export function mock(
  data: Array<defs.TheNewSalesPlanQuarterlyWeeks>,
): Promise<defs.StandardReturn<boolean>> {
  return defHttp.post({
    url: '/mock/web/plan/add',
    data,
  });
}
